import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import hasPath from 'lodash/has';
import reduxStore from '../reduxStore.js';
import { signinUser } from '../actions/index';
import {
  authManager,
  publisherManager,
  invitationManager,
  soundcastManager,
} from '../helpers/managers';
const {
  extractPublisherIAPHubDetails,
} = require('../../server/scripts/utils')();

const addInvitedSoundcastsToUser = async (...args) => {
  const [
    userInfo = {},
  ] = args;
  console.log('addInvitedSoundcastsToUser', args);

  try {
    const invitations = await invitationManager.getActiveInvitations(userInfo.email);
    if (isEmpty(invitations)) {
      return false;
    }

    const soundcastPromises = invitations.map(soundcastId => {
      return new Promise( async resolve => {
         resolve({
           ... await soundcastManager.getById(soundcastId),
           soundcastId,
         });
      });
    });
  
    const soundcasts = await Promise.all(soundcastPromises);

    const addSoundcastPromises = soundcasts.filter(item => !isEmpty(item)).map(soundcast => {
      const checked = 0;
      const totalPrice = hasPath(soundcast, `prices.${checked}.price`)
        ? Number(soundcast.prices[checked].price)
        : 0;

      return addSoundcastToUser(
        null,  // empty charge
        userInfo,
        soundcast.soundcastId,
        soundcast,
        checked,
        null, // not used
        null,  // empty coupon
        totalPrice,
        () => {}
      );
    });
  
    await Promise.all(addSoundcastPromises);

    return true;
  } catch (err) {
    console.error(`ERROR: addInvitedSoundcastsToUser errored - ${err.message}`);
  }

  return false;
};

// Old client/containers/soundcast_landing_page/components/payment.js > addSoundcastToUser function:
//   const addSoundcastToUser = (charge, userInfoFromProps, soundcastId) => {
const addSoundcastToUser = async (...args) => {
  const [
    charge = {},
    userInfo = {},
    soundcastId,
    soundcast,
    checked,
    _sumTotal, // not used
    coupon = '',
    totalPrice,
    history,
  ] = args;
  console.log('addSoundcastToUser', args);

  const traceLog = []; // DBG

  if (!isEmpty(userInfo) && !isEmpty(userInfo.email)) {
    // check loggedin ???
    const authUser = authManager.getCurrentUser() || {};
    if (isEmpty(authUser)) {
      throw new Error('Logged in user is missing');
    }
    traceLog.push(`auth: uid=${JSON.stringify(authUser.uid)} email=${JSON.stringify(authUser.email)}`); // DBG
  } else {
    // console.log(`Error: addSoundcastToUser empty user`);
    return false;
  }

  let { id: userId, email: emails = [] } = userInfo || {};
  traceLog.push(`userInfo: id=${JSON.stringify(userId)} email=${JSON.stringify(emails)}`); // DBG

  if (isEmpty(userId)) {
    // this fixes the "old" userInfo which does not have an id field
    try {
      const userEmail = isArray(emails) ? emails[0] : emails;
      if (!isEmpty(userEmail)) {
        // retrieve the userId by email
        const { status, data } = await Axios.get(`/api/user/lookup/${userEmail}`);
        const { uid = '', email: vemail } = data || {};
        if (isEqual(status, 200) && isEqual(userEmail.toLowerCase(), vemail.toLowerCase())) {
          userId = uid;
          traceLog.push(`empty userId fix by email ${JSON.stringify(userEmail)} ${userId}`); // DBG
        }  
      }
    } catch (err) {
      traceLog.push(`empty userId error ${err && err.toString()}`); // DBG
    }
  }

  const isAddToUserSuccess = await new Promise(async resolve => {
    try {
      const addToUserData = {
        soundcastId,
        userId,
        checked,
        charge: null,
        coupon,
        totalPrice,
        stripeId: null,
        traceLog, // DBG
      };

      await Axios.post(`/api/v2/soundcast/${soundcastId}/add_to_user`, addToUserData);

      resolve(true);
    } catch (err) {
      console.error(err.message);
      resolve(false);
    }
  });

  /// --> sending email moved to POST /api/v2/soundcast/${soundcastId}/add_to_user

  if (isAddToUserSuccess) {
    await redirectToSoundcastNoticePage(soundcast, history);
  }
};

const redirectToSoundcastNoticePage = async (soundcast, history) => {
  const {
    publisherID: publisherId,
    title: soundcastTitle,
    platformCustomer = null,
  } = soundcast || {};

  if (!isEmpty(platformCustomer)) {
    // set userInfo.stripe_id
    reduxStore.dispatch(signinUser({ stripe_id: platformCustomer }));
  }

  // pull soundcast publisher details
  const publisher = isEmpty(publisherId) ? {} : await publisherManager.getById(publisherId);
  if (isEmpty(publisher)) {
    console.log('Warning redirectToSoundcastNoticePage empty soundcast publisher');
  }

  // redirect now to notice page
  const {
    appName,
    playstoreUrl: android,
    appstoreUrl: ios,
  } = extractPublisherIAPHubDetails(publisher);

  const state = {
    soundcastTitle,
    appName,
    ios,
    android,
  };

  window.soundwiseNoticePageState = state; // hard fix for notice page
  if (isFunction(history)) {
    return history(state);
  }

  history.replace({ pathname: '/notice', state });
};

export { 
  addSoundcastToUser,
  addInvitedSoundcastsToUser,
  redirectToSoundcastNoticePage,
};
